const ones = [
    '',
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten',
    'Eleven',
    'Twelve',
    'Thirteen',
    'Fourteen',
    'Fifteen',
    'Sixteen',
    'Seventeen',
    'Eighteen',
    'Nineteen'
];
const tens = [
    '',
    '',
    'Twenty',
    'Thirty',
    'Forty',
    'Fifty',
    'Sixty',
    'Seventy',
    'Eighty',
    'Ninety'
];
const format = (value)=>{
    const cents = value - Math.floor(value);
    const roundedCents = Math.round(cents * 100);
    let nbr = Math.floor(value);
    const tn = Math.floor(nbr / 1000000000000);
    nbr -= tn * 1000000000000;
    const bn = Math.floor(nbr / 1000000000);
    nbr -= bn * 1000000000;
    const gn = Math.floor(nbr / 1000000);
    nbr -= gn * 1000000;
    const kn = Math.floor(nbr / 1000);
    nbr -= kn * 1000;
    const hn = Math.floor(nbr / 100);
    nbr -= hn * 100;
    const dn = Math.floor(nbr / 10);
    nbr -= dn * 10;
    const n = nbr % 10;
    let res = '';
    if (tn) {
        res += (res.length === 0 ? '' : ' ') + format(tn) + ' Trillion';
    }
    if (bn) {
        res += (res.length === 0 ? '' : ' ') + format(bn) + ' Billion';
    }
    if (gn) {
        res += (res.length === 0 ? '' : ' ') + format(gn) + ' Million';
    }
    if (kn) {
        res += (res.length === 0 ? '' : ' ') + format(kn) + ' Thousand';
    }
    if (hn) {
        res += (res.length === 0 ? '' : ' ') + format(hn) + ' Hundred';
    }
    if (dn || n) {
        if (res.length > 0) {
            res += ' ';
        }
        if (dn < 2) {
            res += ones[dn * 10 + n];
        } else {
            res += tens[dn];
            if (n) {
                res += '-' + ones[n];
            }
        }
    }
    if (roundedCents) {
        res += (res.length === 0 ? '' : ' and ') + roundedCents + '/100';
    }
    if (res.length === 0) {
        res = 'Zero';
    }
    return res;
};
export const formatNumberToText = (value)=>{
    if (!value) {
        return null;
    }
    const numericValue = typeof value === 'string' ? parseFloat(value.replace(/[^0-9.]+/g, '')) : value;
    if (isNaN(numericValue)) {
        return null;
    }
    return format(numericValue);
};

//# sourceMappingURL=formatNumberToText.js.map